import getStore from '../data/store/store';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';

export default function isSuggestedRepliesEnabled(): boolean {
    // Fetch the option state from the store if possible (not null), otherwise from the backend.
    const userConfiguration: OwaUserConfiguration = getUserConfiguration();
    const userOptions: UserOptionsType = userConfiguration && userConfiguration.UserOptions;

    if (!userOptions) {
        // Can't get user options, just assume feature is off.
        return false;
    } else {
        return getFallbackValueIfNull(
            getStore().isEnabled,
            userOptions.WebSuggestedRepliesEnabledForUser
        );
    }
}
